import { initializeApp } from 'firebase/app';
import { getFirestore /*, connectFirestoreEmulator */ } from 'firebase/firestore';
import { getStorage /*, connectStorageEmulator */ } from 'firebase/storage';
import { getFunctions /*,connectFunctionsEmulator */ } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

const config = {
  apiKey: 'AIzaSyDfw4UPaWv8YdmdYihVfFnAJxLVZDOw1nk',
  authDomain: 'hub.emstone.com',
  databaseURL: 'https://emstone-hub.firebaseio.com',
  projectId: 'emstone-hub',
  storageBucket: 'emstone-hub.appspot.com',
  messagingSenderId: '1042803287856',
  appId: '1:1042803287856:web:a9fd0d310f466daf878af5',
  measurementId: 'G-22LRWEW273',
};

const app = initializeApp(config);

const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app);
const analytics = getAnalytics(app);

// 애뮬레이터
// connectFirestoreEmulator(db, 'localhost', 8180);
// connectFunctionsEmulator(functions, 'localhost', 5000);
// connectStorageEmulator(storage, 'localhost', 9199);

export { db, auth, storage, functions, analytics };
